import membershipTiers from "../services/purchase.packages";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        membershipTiers: [],
        membershipTierDetails: {
        },
        members: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        editing: false,
        searching: false,
        errors: null
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        editing(state, value) {
            state.editing = value;
        },
        membershipTiers(state, membershipTiers) {
            state.membershipTiers = membershipTiers;
            state.loading = false;
            state.searching = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        setDetails(state, details) {
            state.membershipTierDetails = details;
        },
        members(state, members) {
            state.members = members;
            state.loading = false;
            state.searching = false;
        }
    },
    actions: {
        async getMembershipTiers({ commit }, param) {
            commit("loading");
            try {
                // let response = await membershipTiers.getMembershipTiers(param);

                let response = {
                    list: [
                        {
                            title: "Basic",
                            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do..",
                            visibility: true,
                            points: 300,
                            uuid: 1,
                            logo: require("@/assets/images/mechanics/tier-basic.png")
                        },
                        {
                            title: "Silver",
                            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do..",
                            visibility: false,
                            points: 300,
                            uuid: 2,
                            logo: require("@/assets/images/mechanics/tier-silver.png")
                        },
                        {
                            title: "Gold",
                            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do..",
                            visibility: false,
                            points: 300,
                            uuid: 3,
                            logo: require("@/assets/images/mechanics/tier-gold.png")
                        },
                        {
                            title: "Platinum",
                            description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do..",
                            visibility: false,
                            points: 300,
                            uuid: 4,
                            logo: require("@/assets/images/mechanics/tier-platinum.png")
                        },
                    ]
                };

                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }

                await commit("membershipTiers", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async getMembers({ commit }, param) {
            commit("loading");
            try {
                // let response = await membershipTiers.getMembers(param);

                // if (param.page == 1) {
                //     await commit("setMembersInitialPageCount", response.list);
                // }

                // await commit("members", response.list);
                // await commit("membersPagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
    }
};